import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Collapsible, CollapsibleContent } from "@shadcn/components/ui/collapsible";
import "../datatables.scss";
import { Input } from '@shadcn/components/ui/input';
import { Card, CardContent as CardBody, CardHeader } from '@shadcn/components/ui/card';
import { Button } from '@shadcn/components/ui/button';
import Select from '@shadcn/components/ui/react-select';
import useQuery from '../../../helpers/JIFI/useQuery';
import { useHistory } from "react-router-dom";
import superagent from 'superagent';
import { backendUrl } from '../../../helpers/consts.js';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useUrlState } from '../../../helpers/useUrlState';
import '../../Skote/Dashboard/skelton.css';
import ProductVariantSelector from '../helpers/ProductVariantSelector.js';
import { Col } from '@shadcn/components/ui/col';
import { Row } from '@shadcn/components/ui/row';
import { TablePagination } from '@components/supply-chain/TablePagination';
import { Dialog, DialogContent, DialogFooter } from '@shadcn/components/ui/dialog';
import { CSVReader } from 'react-papaparse';

const collateStockSummary = (stockData, quantity) =>
  Object.fromEntries((stockData || []).map(item => [item.sku, item[quantity] ?? 0]));

const ProductRow = ({
  lineKey,
  item,
  products,
  editQuantityRow,
  isStoreStockLoading,
  isThirdPartyStockLoading,
  editVariantRow,
  editProductRow,
  storeOnHand,
  thirdPartyAvailable,
  removeRow,
}) => {
  const setSelectedVariant = (variant) => {
    editProductRow(lineKey, variant?.product);
    editVariantRow(lineKey, variant?._id, variant?.sku, variant?.name);
  };

  return (
    <Row className="gap-6" style={{ padding: '16px 0' }}>
      <Col md="8" className="sm:w-8/12">
        <ProductVariantSelector
          products={products}
          setSelectedVariant={setSelectedVariant}
          selectedVariant={item}
          hidePersonalisationOptions
        />
      </Col>
      <Col md="3" className="sm:w-3/12">
        <Input
          style={{ width: '100%', ...(item.quantity <= 0 ? { border: '1px solid red' } : {}) }}
          type="number"
          value={item.quantity || ""}
          onChange={(e) => editQuantityRow(lineKey, e.target.value)}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'stretch', width: '100%', whiteSpace: 'nowrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span className={`text-${thirdPartyAvailable > 0 ? 'success' : 'warning'}`}>Available:</span>
            <h5 className={`font-size-13 text-left mb-0 ${!isThirdPartyStockLoading && thirdPartyAvailable !== undefined ? '' : 'placeholder'}`}>
              {!isThirdPartyStockLoading && thirdPartyAvailable !== undefined ? thirdPartyAvailable : ' '}
            </h5>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', alignSelf: 'center', gap: 10, transform: 'translateX(-8px)' }}>
            <span className={`text-${storeOnHand > 0 ? 'success' : 'warning'}`}>Store SOH:</span>
            <h5 className={`font-size-13 text-left mb-0 ${!isStoreStockLoading && storeOnHand !== undefined ? '' : 'placeholder'}`}>
              {!isStoreStockLoading && storeOnHand !== undefined ? storeOnHand : ' '}
            </h5>
          </div>
        </div>
      </Col>
      <Col xs="1" className="sm:w-1/12">
        <Button onClick={() => removeRow(lineKey)} variant="destructive">
          X
        </Button>
      </Col>
    </Row>
  );
};

const StockInput = ({
  stock,
  setStock,
  productData,
  maxCounts,
  storeOnHand,
  thirdPartyAvailableCounts,
  isStoreStockLoading,
  isThirdPartyStockLoading,
}) => {
  const handleAddRow = () => {
    setStock(prev => [...prev, {
      product: "",
      variant: "",
      name: "",
      quantity: 0,
      sku: "",
    }]);
  };

  const editProductRow = (id, productId) => {
    setStock(prev => {
      const newList = [...prev];
      newList[id].product = productId;
      newList[id].quantity = 0;
      const product = productData.find(val => `${val._id}` === `${productId}`);
      newList[id].variant = product?.variants[0]?._id;
      return newList;
    });
  };

  const editVariantRow = (id, val, sku, name) => {
    setStock(prev => {
      const newList = [...prev];
      newList[id].variant = val;
      newList[id].quantity = 0;
      newList[id].sku = sku;
      newList[id].name = name;
      return newList;
    });
  };

  const editQuantityRow = (id, val) => {
    setStock(prev => {
      const newList = [...prev];
      const sku = newList[id].sku;
      const maxCount = maxCounts[sku] || 0;
      const normalizedValue = val.replace(/^0+(?=\d)/, "");
      let parsedInput = parseInt(normalizedValue);
      if (Number.isNaN(parsedInput)) parsedInput = 0;
      if (parsedInput > maxCount) parsedInput = maxCount;
      if (parsedInput < 0) parsedInput = 0;
      newList[id].quantity = parsedInput;
      return newList;
    });
  };

  const removeRow = (id) => {
    setStock(prev => prev.filter((_, key) => key !== id));
  };

  const handleOnDrop = (data) => {
    setStock(prev => {
      const next = [...prev];
      data.forEach((line, key) => {
        // Skip the header row (SKU, Quantity).
        if (key === 0) return;

        const sku = `${line.data[0] || ''}`.trim();
        if (!sku) return;

        const product = productData
          ? productData.find(val => val.variants.find(variant => variant.sku === sku) != undefined)
          : undefined;
        if (product == undefined) return;

        const variant = product.variants.find(variant => variant.sku === sku);
        if (variant == undefined) return;

        const maxCount = maxCounts[sku] || 0;
        let quantity = parseInt(`${line.data[1] || ''}`.trim());
        if (Number.isNaN(quantity)) quantity = 0;
        if (quantity > maxCount) quantity = maxCount;
        if (quantity < 0) quantity = 0;

        const existingIndex = next.findIndex(s => s.sku === sku);
        if (existingIndex >= 0) {
          // Update the quantity of an SKU that is already in the table.
          next[existingIndex] = { ...next[existingIndex], quantity };
        } else {
          next.push({
            product: product._id,
            variant: variant._id,
            name: variant.name,
            quantity,
            sku,
          });
        }
      });

      next.sort((a, b) => (a.sku < b.sku) ? -1 : (a.sku > b.sku) ? 1 : 0);
      return next;
    });
  };

  const handleOnError = (err) => {
    console.log(err);
  };

  const handleOnRemoveFile = () => {};

  const products = productData ? productData.map(product => {
    const variants = product.variants
      .filter(variant => !stock.some(stockItem => stockItem.variant === variant._id))
      .map(variant => ({
        _id: variant._id,
        name: variant.name,
        selected: stock.findIndex(val => val.variant === variant._id),
        sku: variant.sku,
        product: product._id,
      }));

    return {
      name: product.name,
      _id: product._id,
      variants,
    };
  }) : [];

  return (
    <>
      {productData !== undefined && (
        <div style={{ marginBottom: 16 }}>
          <div className="mb-2">
            <a href="https://jifi-storage-staging.s3-ap-southeast-2.amazonaws.com/comment_file_1637273421528.csv"> CSV Template </a>
          </div>
          <CSVReader
            onDrop={handleOnDrop}
            onError={handleOnError}
            onRemoveFile={handleOnRemoveFile}
          >
            <span>Drop CSV file here or click to upload. (Columns: SKU, Quantity)</span>
          </CSVReader>
        </div>
      )}
      <Row>
        <Col xs="8" className="sm:w-8/12">Variant</Col>
        <Col xs="4" className="sm:w-4/12">Quantity</Col>
      </Row>
      <br />
      {productData && stock.map((stockObjectRow, lineKey) => (
        <ProductRow
          key={lineKey}
          item={stockObjectRow}
          lineKey={lineKey}
          products={products}
          editQuantityRow={editQuantityRow}
          editProductRow={editProductRow}
          editVariantRow={editVariantRow}
          isStoreStockLoading={isStoreStockLoading}
          isThirdPartyStockLoading={isThirdPartyStockLoading}
          storeOnHand={stockObjectRow?.sku ? storeOnHand[stockObjectRow.sku] ?? 0 : undefined}
          thirdPartyAvailable={stockObjectRow?.sku ? thirdPartyAvailableCounts[stockObjectRow.sku] ?? 0 : undefined}
          removeRow={removeRow}
        />
      ))}
      {productData === undefined ? (
        <div className="spinner-border text-primary m-1" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 12 }}>
          <Button onClick={handleAddRow} variant="primary">Add</Button>
          <span />
        </div>
      )}
    </>
  );
};

const ReturnHistoryLine = ({ historyObject, lineKey, isOpen, updateHistoryOpen }) => (
  <div id="accordion">
    <Card className="mb-1">
      <CardHeader onClick={() => updateHistoryOpen(lineKey)} className="p-3 bg-[#f6f6f6]" id="headingOne">
        <h6 className="m-0 font-14">
          <span style={{ cursor: "pointer" }} className={historyObject.status === 'error' ? 'text-danger' : 'text-success'}>
            {historyObject.locationFrom?.display_name || historyObject.locationFrom?.name || 'Store'} to {historyObject.locationTo?.display_name || historyObject.locationTo?.name || 'Warehouse'} || Returned:
            {(new Date(historyObject.createdAt)).toDateString()}
            {historyObject.status === 'error' && ' - ERROR'}
          </span>
        </h6>
      </CardHeader>
      <Collapsible open={isOpen} onOpenChange={() => updateHistoryOpen(lineKey)}>
        <CollapsibleContent>
          <Card className="pt-6">
            <CardBody>
              {historyObject.lines.map((line, key) => (
                <div key={key}>{line.quantity} x {line.sku}</div>
              ))}
              {historyObject.error_message && <div className="text-danger mt-3">{historyObject.error_message}</div>}
            </CardBody>
          </Card>
        </CollapsibleContent>
      </Collapsible>
    </Card>
    <br /><br />
  </div>
);

const ReturnToWarehousePage = () => {
  const returnRequestRef = useRef();
  const location = useLocation();
  const history = useHistory();
  const [refresh, setRefresh] = useState(true);
  const [modal, setModal] = useState(false);
  const togglemodal = () => setModal(prev => !prev);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [selectedStatus, setSelectedStatus] = useState('Completed');
  const [stockReturn, setStockReturn] = useState([]);
  const [historyOpen, setHistoryOpen] = useState([]);
  const [loading, setLoading] = useState(false);
  const positiveStockReturn = useMemo(
    () => stockReturn.filter(line => Number(line.quantity) > 0),
    [stockReturn],
  );
  const selectedSkus = useMemo(
    () => [...new Set(stockReturn.map(item => item.sku).filter(Boolean))].sort(),
    [stockReturn],
  );

  const [productResponse] = useQuery({
    url: `/product/variant-options`,
    refresh,
  });
  const productData = productResponse;

  const [bookableLocations] = useQuery({
    url: `/inventory/getBookableLocations`,
    refresh,
  });

  const [stateData, setStateData] = useUrlState({
    selectedFromLocation: undefined,
    selectedToLocation: undefined,
  });

  useEffect(() => {
    if (location.search === '') {
      setStateData({
        selectedFromLocation: undefined,
        selectedToLocation: undefined,
      });
    }
  }, [location.search]);

  const { selectedFromLocation, selectedToLocation } = stateData;

  const storeOptions = useMemo(() => {
    if (!bookableLocations || bookableLocations.length === 0) return [];
    const selectedWarehouse =
      bookableLocations.find(warehouse => warehouse.name === selectedToLocation?.value) || bookableLocations[0];
    return selectedWarehouse.stockDropLocations.map(store => ({ label: store.display_name, value: store.name }));
  }, [bookableLocations, selectedToLocation]);

  const warehouseOptions = useMemo(() => {
    if (!bookableLocations) return [];
    return bookableLocations.map(warehouse => ({ label: warehouse.display_name, value: warehouse.name }));
  }, [bookableLocations]);

  useEffect(() => {
    if (warehouseOptions.length === 0) return;
    if (!warehouseOptions.some(option => option.value === selectedToLocation?.value)) {
      setStateData(prev => ({
        ...prev,
        selectedToLocation: warehouseOptions[0],
      }));
    }
  }, [warehouseOptions, selectedToLocation]);

  useEffect(() => {
    if (storeOptions.length === 0) return;
    if (!storeOptions.some(option => option.value === selectedFromLocation?.value)) {
      setStateData(prev => ({
        ...prev,
        selectedFromLocation: storeOptions[0],
      }));
    }
  }, [storeOptions, selectedFromLocation]);

  const [storeStockData, storeStockState] = useQuery({
    url: `/inventory/fetchStockSummary`,
    refresh,
    queryData: {
      location: selectedFromLocation?.value,
    },
    runQuery: !!selectedFromLocation?.value,
  });
  const [thirdPartyStockData, thirdPartyStockState] = useQuery({
    url: `/inventory/fetchStockSummary`,
    refresh,
    queryData: {
      location: selectedToLocation?.value,
      skus: selectedSkus.join(','),
    },
    runQuery: !!selectedToLocation?.value && selectedSkus.length > 0,
  });
  const storeAvailableCount = useMemo(
    () => collateStockSummary(storeStockData, 'available'),
    [storeStockData],
  );
  const storeOnHandCount = useMemo(
    () => collateStockSummary(storeStockData, 'onHand'),
    [storeStockData],
  );
  const thirdPartyAvailableCount = useMemo(
    () => collateStockSummary(thirdPartyStockData, 'available'),
    [thirdPartyStockData],
  );

  const [returnHistoryData, returnHistoryState] = useQuery({
    url: `/inventory/fetchReturnToWarehouse`,
    queryData: {
      page,
      perPage,
      location: selectedToLocation?.value,
      status: selectedStatus.toLowerCase(),
    },
    refresh,
  });

  useEffect(() => {
    if (returnHistoryData) {
      setHistoryOpen(returnHistoryData.map(() => false));
    }
  }, [returnHistoryData]);

  const updateHistoryOpen = (key) => {
    setHistoryOpen(prev => {
      const newData = [...prev];
      newData[key] = !newData[key];
      return newData;
    });
  };

  const setSelectedFromLocation = (selectedFrom) => {
    setStateData(prev => ({
      ...prev,
      selectedFromLocation: selectedFrom,
    }));
    setStockReturn([]);
  };

  const setSelectedToLocation = (selectedTo) => {
    setStateData(prev => ({
      ...prev,
      selectedToLocation: selectedTo,
    }));
    setStockReturn([]);
  };

  const handleSubmit = () => {
    setLoading(true);
    const request = {
      locationFrom: selectedFromLocation?.value,
      locationTo: selectedToLocation?.value,
      pullStock: positiveStockReturn,
    };
    const fingerprint = JSON.stringify(request);
    if (returnRequestRef.current?.fingerprint !== fingerprint) {
      returnRequestRef.current = { fingerprint, key: crypto.randomUUID() };
    }
    superagent.post(`${backendUrl}/inventory/bookReturnToWarehouse`)
      .send({
        ...request,
        idempotencyKey: returnRequestRef.current.key,
      })
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .on('error', (response) => {
        const code = response.status;
        setLoading(false);
        history.replace(history.location.pathname, {
          errorStatusCode: code,
        });
      })
      .then(response => {
        const code = response.status;
        if (code > 400) {
          history.replace(history.location.pathname, {
            errorStatusCode: code,
          });
        } else {
          returnRequestRef.current = undefined;
          setStockReturn([]);
          setModal(false);
          setRefresh(prev => !prev);
        }
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <div className="page-content">
      <div className="w-full px-3 mx-auto xl:max-w-[85%]">
        <Row className="mb-2 gap-6 flex-wrap sm:flex-nowrap">
          <Col className={`${stockReturn.length > 0 ? 'md:w-8/12' : 'md:w-full'} lg:w-${stockReturn.length > 0 ? '8/12' : 'full'} xl:w-${stockReturn.length > 0 ? '8/12' : 'full'}`}>
            <div className="pt-3">
              <p className="text-[23px] font-medium">Return To Warehouse</p>
            </div>
            <Card className="mb-6">
              <CardBody>
                <div className="my-2">
                  <div className="mb-4">
                    <label>Warehouse:</label>
                    <Select
                      options={storeOptions}
                      value={selectedFromLocation}
                      onChange={setSelectedFromLocation}
                    />
                  </div>
                  <div className="mb-4">
                    <label>3PL:</label>
                    <Select
                      options={warehouseOptions}
                      value={selectedToLocation}
                      onChange={setSelectedToLocation}
                    />
                  </div>
                </div>
                <br />
                <StockInput
                  maxCounts={storeAvailableCount}
                  stock={stockReturn}
                  setStock={setStockReturn}
                  productData={productData}
                  storeOnHand={storeOnHandCount}
                  thirdPartyAvailableCounts={thirdPartyAvailableCount}
                  isStoreStockLoading={storeStockState === 'loading'}
                  isThirdPartyStockLoading={thirdPartyStockState === 'loading'}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 12 }}>
                  <span />
                  {(productData && positiveStockReturn.length > 0) && (
                    <Button onClick={togglemodal} variant="primary" className="btn-lg btn-rounded">
                      Submit
                    </Button>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
          {stockReturn.length > 0 && (
            <Col className="md:w-4/12 lg:w-4/12 xl:w-4/12">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4 pt-6">STOCK SUMMARY</h4>
                  <br />
                  {productData && stockReturn.length > 0 && 'Returning:'}
                  {stockReturn.map((line, lineKey) => (
                    <div key={lineKey}>
                      <span className="text-success">{line.quantity}</span> x {line.sku}
                    </div>
                  ))}
                </CardBody>
              </Card>
            </Col>
          )}
        </Row>

        <Row>
          <Col className="w-full">
            <Row>
              <h4 className="text-[23px] font-medium leading-9 py-3">Return To Warehouse History</h4>
            </Row>
            <Card className="pt-6 mb-6">
              <CardBody>
                <Row>
                  <Col sm="12" className="sm:w-full">
                    <div className="mb-4">
                      <label>Status:</label>
                      <Select
                        options={['Completed', 'Error'].map(val => ({ value: val, label: val }))}
                        value={{ value: selectedStatus, label: selectedStatus }}
                        onChange={e => setSelectedStatus(e.value)}
                      />
                    </div>
                  </Col>
                </Row>
                {returnHistoryState === 'success' && returnHistoryData ? returnHistoryData.map((historyObject, key) => (
                  <ReturnHistoryLine
                    key={historyObject._id}
                    historyObject={historyObject}
                    updateHistoryOpen={updateHistoryOpen}
                    isOpen={historyOpen[key]}
                    lineKey={key}
                  />
                )) : (
                  <div className="spinner-border text-primary m-1 mb-6" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                )}
                <TablePagination count={100} page={page} setPage={setPage} perPage={perPage} setPerPage={setPerPage} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <Dialog open={modal} role="dialog" autoFocus={true} centered={true} className="exampleModal" tabindex="-1" size="lg" onOpenChange={togglemodal}>
        <DialogContent className="z-[1600] max-h-[80vh] overflow-y-auto min-w-[50vw]">
          <h4 className="card-title mb-4">RETURN STOCK SUMMARY</h4>
          <p>Any stock with 0 quantity will not be returned or shown in the return history.</p>
          <br />
          {positiveStockReturn.map(line => (
            <div key={line.variant}>
              <span className="text-success">{line.quantity}</span> x {line.sku}
            </div>
          ))}
          <DialogFooter>
            {loading ? (
              <div className="spinner-border text-primary m-1" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              <Button onClick={handleSubmit} variant="primary" className="btn-lg btn-rounded">
                Confirm
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ReturnToWarehousePage;
